// src/constants/cards.ts

export const CARD_LABELS: { [key: string]: { ja: string; en: string } } = {
    standard: { ja: "スタンダード", en: "STANDARD" },
    logical: { ja: "ロジカル", en: "LOGICAL" },
    storytelling: { ja: "ストーリーテリング", en: "STORYTELLING" },
    life: { ja: "ライフ", en: "LIFE" },
    emotion: { ja: "エモーション", en: "EMOTION" },
    free: { ja: "フリー", en: "FREE" },
  };

  // 👇 ここから追加（無料トライアル用の固定13枚デッキ）
export const CARDS_DEMO_JP: string[] = [
  "たとえば",
  "だから",
  "少なくとも",
  "もし",
  "さすがに",
  "いつか",
  "残念ながら",
  "偶然にも",
  "ところが",
  "どうやら",
  "ふり返ると",
  "10年後",
  "たまには",
];
